import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PersonalDetailPage } from './personal-detail.page';

const routes: Routes = [
  {
    path: '', 
    component: PersonalDetailPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PersonalDetailPageRoutingModule {}
